import React from "react";
import "./Footer.css";
import logo from "../images/logo.png";
import epanek_logo from "../images/epanek.jpg"


function Footer(props) {
    return(
        // <div id = "footer">
        //     <div className="footer-wrapper">
        //         <div className="img-with-text"> 
        //             <img src={logo} width="60" height="60" alt=""/>
        //             <h5> ENIRISST</h5>
        //         </div>

        //         <div className="links">
        //             <p>ΧΡΗΣΙΜΑ LINKS</p>
        //             <a href="http://www.ypa.gr/el/">http://www.ypa.gr/el/</a>
                    
        //             <a href="https://www.statistics.gr/el/statistics/-/publication/SME09/-">https://www.statistics.gr/el/statistics/-/publication/SME09/-</a>
        //             <a href="https://www.eurocontrol.int/Economics/DailyTrafficVariation-States.html">https://www.eurocontrol.int/Economics/DailyTrafficVariation-States.html</a>
        //         </div>

        //         <div className="communication-links">
        //             <p>ΕΠΙΚΟΙΝΩΝΙΑ</p>
        //             <p>enirisst@aegean.gr</p>
        //         </div>

                
        //     </div>

        //     <p style = {{color : "white", marginTop: "5%"}}>Η υπηρεσία αυτή υλοποιήθηκε στο πλαίσιο της Πράξης «ENIRISST-Intelligent Research Infrastructure for Shipping, Supply Chain, Transport and Logistics” (MIS 5027930) που εντάσσεται στη Δράση «Ενίσχυση Υποδομών Έρευνας και Καινοτομίας» και χρηματοδοτείται από το Επιχειρησιακό Πρόγραμμα «Ανταγωνιστικότητα, Επιχειρηματικότητα και Καινοτομία» στο πλαίσιο του ΕΣΠΑ 2014-2020, με τη συγχρηματοδότηση της Ελλάδας και της Ευρωπαϊκής Ένωσης (Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης)</p>



        //     <hr id="line"></hr>
            
        //     <div className="copyright-text">
                
        //         <p>Copyright 2022 All rights reserved</p>
        //         <div  className = "vertical-line" ></div>
        //         <p>This template is made with by </p>
        //         <p id = "name">  NAME</p>
        //     </div>

        //     <img src={epanek_logo} width="100%" height="20%" alt=""/>
        // </div>

        <footer className="footer">
            <div className = "footer-wrapper">
                <div className="left-content">
                    <img src={logo} width="60" height="60" alt=""/>
                    <h5> ENIRISST</h5>
                </div>

                <div className="footer-content">
                    <div className="useful-websites">
                        <p>ΧΡΗΣΙΜΑ LINKS</p>
                        <a href="http://www.ypa.gr/el/">http://www.ypa.gr/el/</a>
                    
                        <a href="https://www.statistics.gr/el/statistics/-/publication/SME09/-">https://www.statistics.gr/el/statistics/-/publication/SME09/-</a>
                        <a href="https://www.eurocontrol.int/Economics/DailyTrafficVariation-States.html">https://www.eurocontrol.int/Economics/DailyTrafficVariation-States.html</a>
                    </div>
                
                    <div className="communication-links">
                        <p>ΕΠΙΚΟΙΝΩΝΙΑ</p>
                        <a href="mailto:enirisst@aegean.gr" className="link">enirisst@aegean.gr</a>
                    </div>
                
                </div>
            </div>

            <p style = {{color : "white", marginTop: "5%"}}>Η υπηρεσία αυτή υλοποιήθηκε στο πλαίσιο της Πράξης «ENIRISST-Intelligent Research Infrastructure for Shipping, Supply Chain, Transport and Logistics” (MIS 5027930) που εντάσσεται στη Δράση «Ενίσχυση Υποδομών Έρευνας και Καινοτομίας» και χρηματοδοτείται από το Επιχειρησιακό Πρόγραμμα «Ανταγωνιστικότητα, Επιχειρηματικότητα και Καινοτομία» στο πλαίσιο του ΕΣΠΑ 2014-2020, με τη συγχρηματοδότηση της Ελλάδας και της Ευρωπαϊκής Ένωσης (Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης)</p>
            <hr id="line"></hr>

            <div className="copyright-text">
                
                <p>Copyright 2022 All rights reserved</p>
            </div>

            <img src={epanek_logo}   height="250vh" width = "100%" alt=""/>
        </footer>
    );
}

export default Footer;

